import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';
// eslint-disable-next-line import/no-named-as-default
import Tournament from '../list/tournament/index';
import TournamentStage from '../list/tournament/stage/index';
import TournamentStageGroup from '../list/tournament/stage/group/index';
import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import TournamentStageGroupMember from '../list/tournament/stage/group/member/index';
import TournamentStageGroupMemberHistory from '../list/tournament/stage/group/member/history/index';

const API_PATH = 'tournaments';
const API_PATH_STAGES = 'tournament-stages';
const API_PATH_GROUPS = 'tournament-stage-groups';

export const TournamentManager = {
  get objects() {
    return {
      ...objectsRHandler(API_PATH, Tournament),
      getUserHistory({ args = [], params } = DEFAULT_PARAMS) {
        const [trounamentId, userId] = args;
        const path = `/${API_PATH}/${trounamentId}/user-history/${userId}`;
        return rHandler(
          apiService.get(path, params),
          (response) => ({
            response,
            item: Object.values(response.data.data).map((i) => new TournamentStageGroupMemberHistory(i, path)),
          }),
          (error) => ({ error }),
        );
      },
    };
  },
  stages: objectsRHandler(API_PATH_STAGES, TournamentStage),
  get groups() {
    return {
      ...objectsRHandler(API_PATH_GROUPS, TournamentStageGroup),
      getMembers({ args = [], params } = DEFAULT_PARAMS) {
        const [id] = args;
        return rHandler(
          apiService.get(`/${API_PATH_GROUPS}/${id}/users`, params),
          (response) => ({
            response,
            items: response.data.data.map((i) => new TournamentStageGroupMember(i, 'users')),
          }),
          (error) => ({ error }),
        );
      },
      addMembers({ args = [], data } = DEFAULT_PARAMS) { // { user_ids: [] },
        const [id] = args;
        return rHandler(
          apiService.post(`/${API_PATH_GROUPS}/${id}/users/add`, data),
          (response) => ({ response }),
          (error) => ({ error }),
        );
      },
      removeMembers({ args = [], data } = DEFAULT_PARAMS) { // { user_ids: [] },
        const [id] = args;
        return rHandler(
          apiService.post(`/${API_PATH_GROUPS}/${id}/users/remove`, data),
          (response) => ({ response }),
          (error) => ({ error }),
        );
      },
      transferMembers({ args = [], data } = DEFAULT_PARAMS) { // { tournament_stage_group_id: Number, user_ids: [] },
        const [id] = args;
        return rHandler(
          apiService.post(`/${API_PATH_GROUPS}/${id}/transfer-users`, data),
          (response) => ({ response }),
          (error) => ({ error }),
        );
      },
      addScores({ args = [], data } = DEFAULT_PARAMS) { // { users: { user_id, score, description?, status? }[] },
        const [id] = args;
        return rHandler(
          apiService.post(`/${API_PATH_GROUPS}/${id}/users/score`, data),
          (response) => ({ response }),
          (error) => ({ error }),
        );
      },
    };
  },
};
